export const expectedContactHeaders: string[] = [
  "id",
  "漢字（姓）",
  "漢字（名）",
  "かな（名）（任意）",
  "かな（姓）（任意）",
  "英字（名）（任意）",
  "英字（姓）（任意）",
  "メールアドレス（任意）",
  "役職名 （任意）",
  "企業名 （任意）",
  "企業電話番号 （任意）",
  "企業FAX番号 （任意）",
  "電話番号（任意）",
  "企業の住所（任意）",
  "企業郵便番号 （任意）",
  "企業ホームページ （任意）",
  "削除フラグ",
];

export const expectedUserHeaders: string[] = [
  "id",
  "漢字（名）",
  "漢字（姓）",
  "かな（名）",
  "かな（姓）",
  "権限　（１：一般者、　２：管理者、　３：連絡先）",
  "部署コード（任意）",
  "役職（任意）",
  "企業名 （任意）",
  "企業の住所（任意）",
  "企業電話番号 （任意）",
  "企業FAX番号 （任意）",
  "メールアドレス（任意）",
  "メールアドレス 2（任意）",
  "アカウント状態（有効：TRUE、無効：FALSE）",
  "一斉発信グループコード（任意）",
  "電話番号",
  "電話番号 2（任意）",
  "ログインID",
  "ログインパスワード",
  "利用アプリ",
  "そのほか情報（任意）",
  "削除フラグ",
];

export const expectedDepartmentHeaders: string[] = [
  "id",
  "部署コード",
  "部署名",
  "部署名かな（任意）",
  "親部署コード（任意）",
  "削除フラグ",
];
